/**
 * Sign in with Google — redirect (Authorization Code) flow.
 *
 * The browser navigates to the backend's /api/auth/google/login, Google
 * redirects back to the backend's callback, and the backend sets an
 * httpOnly session cookie before sending the browser home. The frontend
 * never sees a token: it just asks the backend "who am I" via /api/auth/me,
 * which the browser answers automatically using the cookie.
 */
import { apiClient } from '@/lib/api'

export type GoogleProfile = {
  sub?: string
  email?: string
  name?: string
  picture?: string
}

export const GOOGLE_LOGIN_URL = '/api/auth/google/login'

/** Navigates the whole page to Google's sign-in - not an XHR/fetch call. */
export function startGoogleLogin(): void {
  window.location.href = GOOGLE_LOGIN_URL
}

/** Resolves to the signed-in profile, or null if signed out / not reachable. */
export async function fetchSessionProfile(): Promise<GoogleProfile | null> {
  try {
    return await apiClient.get<GoogleProfile>('/auth/me')
  } catch {
    return null
  }
}

export async function endSession(): Promise<void> {
  try {
    await apiClient.post('/auth/logout')
  } catch {
    /* best-effort - the cookie also just expires on its own */
  }
}
